import app from '@/main'
import axios from 'axios'
import { setToken, getToken, removeToken } from '@/auth/auth'
import router from '@/router'
import store from '@/store'
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 600000 // request timeout
})
// 设置每次session不变
service.defaults.withCredentials = true

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken() !== undefined) {
    config.headers['Token'] = getToken()
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  // response => response,
  response => {
    const res = response.data
    // 如果有值，需要更新Token，延长用户登录状态
    if (res.token && res.token.length > 0) {
      removeToken()
      setToken(res.token)
    }
    // 请求失败的情况
    if (res.status !== '2000') {
        // Token 过期,未登录
      if (res.status === '4000') {
        store.dispatch('user/logOutAction').then(() => {
          removeToken()
          router.push({
            name: 'login'
          })
        })
      } else {
        app.$vux.toast.text(res.message, 'middle')
      }
    }
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    if (error.message === 'Network Error') {
      app.$vux.toast.text('网络错误', 'middle')
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js